import { API_WIZARD_DEAL_SERVICE, TILDA_PATHS } from 'lib/constants';
import ModalRedirectToPageWizard from './modalRedirectToPageWizard';

interface IModalTradeInProps {
  isOpen: boolean;
  data: any;
  onDismiss: (value: boolean) => void;
}

const TEXT_DEAL_SERVICE =
  'Юридическое сопровождение и проведение сделок любой сложности. Стоимость 30 000 ₽';

const TITLE_DEAL_SERVICE = 'Сделка с Reit';

const ModalRedirectToPageWizardDealService = ({ isOpen, data, onDismiss }: IModalTradeInProps) => {
  const handleRedirect = () => {
    window.open(TILDA_PATHS.itReit.dealService, "_blank");
  };

  return (
    <ModalRedirectToPageWizard
      title={TITLE_DEAL_SERVICE}
      text={TEXT_DEAL_SERVICE}
      onRedirect={handleRedirect}
      onDismiss={onDismiss}
      isOpen={isOpen}
    />
  );
};
export default ModalRedirectToPageWizardDealService;
